module.exports = __webpack_public_path__ + "img/kort-6.ea1b6ff0.jpg";